import { all, put, takeLatest } from 'redux-saga/effects';
import {
  fetchSummaryCollapseStatus,
  saveSummaryCollapseStatus,
} from '../routines';

export function* fetchSelectedFieldsSaga({ payload }) {
  const { scope } = payload;
  try {
    const status = JSON.parse(
      localStorage.getItem(`${scope}-SummaryCollapsed`)
    );
    yield put(fetchSummaryCollapseStatus.success({ scope, status }));
  } catch (error) {
    yield put(fetchSummaryCollapseStatus.failure({ error }));
  }
}

export function* saveSelectedFieldsSaga({ payload }) {
  const { scope, status } = payload;
  try {
    localStorage.setItem(`${scope}-SummaryCollapsed`, status);
    yield put(saveSummaryCollapseStatus.success({ scope, status }));
  } catch (error) {
    yield put(saveSummaryCollapseStatus.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchSummaryCollapseStatus.TRIGGER, fetchSelectedFieldsSaga),
    takeLatest(saveSummaryCollapseStatus.TRIGGER, saveSelectedFieldsSaga),
  ]);
}
